const PROJECT_NAME = "CAPRONIK JEANS STUDIO";
const PROJECT_ADDRESS =
  "Saksham Plaza, Peer Gali, Indore, Madhya Pradesh, India";
const PROJECT_CONTACT = "+91-958400-9024";
const PROJECT_EMAIL = "capronikjeans@gmail.com";
const PROJECT_CONTACT_EMAIL = "contact@capronik.com";
const PROJECT_WORKING_HOURS = "Mon-Sun 10am - 7pm IST";

const SOCIAL_MEDIA_LINKS = [
  {
    name: "facebook",
    url: "https://www.facebook.com/capronik",
    class: "fa-brands fa-facebook-f",
  },
  {
    name: "instagram",
    url: "https://www.instagram.com/capronik",
    class: "fa-brands fa-instagram",
  },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/company/capronik",
    class: "fa-brands fa-linkedin-in",
  },
];

export {
  PROJECT_NAME,
  PROJECT_ADDRESS,
  SOCIAL_MEDIA_LINKS,
  PROJECT_CONTACT,
  PROJECT_EMAIL,
  PROJECT_CONTACT_EMAIL,
  PROJECT_WORKING_HOURS,
};
